<ng-container [formGroup]="timeParts">
  <mat-form-field>
    <input
      matInput
      type="number"
      [placeholder]="!showMeridian?'HH':'hh'"
      formControlName="hh"
      size="2"
      maxlength="2"
      (wheel)="_onWheel($event)"
      [max]="showMeridian?12:23"
      min="0"
      (input)="_onInput($event)"
      (blur)="_onTouched()"
      autocomplete="off"
      (focus)="_onFocus()"
      (focusout)="_onFocusOut()"
    />
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      type="number"
      placeholder="mm"
      formControlName="mm"
      size="2"
      maxlength="2"
      max="59"
      min="0"
      (wheel)="_onWheel($event)"
      (input)="_onInput($event)"
      (blur)="_onTouched()"
      (focus)="_onFocus()"
      (focusout)="_onFocusOut()"
    />
  </mat-form-field>
  <mat-form-field *ngIf="showSeconds">
    <input
      matInput
      type="number"
      placeholder="ss"
      formControlName="ss"
      size="2"
      maxlength="2"
      max="59"
      min="0"
      (wheel)="_onWheel($event)"
      (input)="_onInput($event)"
      (blur)="_onTouched()"
      (focus)="_onFocus()"
      (focusout)="_onFocusOut()"
    />
  </mat-form-field>
  <mat-form-field *ngIf="showMilliseconds">
    <input
      matInput
      type="number"
      placeholder="ms"
      formControlName="ms"
      size="3"
      maxlength="3"
      max="999"
      min="0"
      (wheel)="_onWheel($event)"
      (input)="_onInput($event)"
      (blur)="_onTouched()"
      (focus)="_onFocus()"
      (focusout)="_onFocusOut()"
    />
  </mat-form-field>
  <button
    mat-button
    (click)="setMeridian(!_isPM)"
    aria-label="AM/PM"
    [disabled]="_isDisabled"
    *ngIf="showMeridian"
  >
    {{_isPM?'PM':'AM'}}
  </button>
</ng-container>
